import './instrument'
import './firebase/appCheckDebugEarly'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { initAudioCacheServiceWorker } from './utils/initServiceWorker'
import {
  redirectFirebaseHostToCustomDomain,
  redirectByGeoIfNeeded
} from '@/utils/regionUtils'
import '@/utils/trackingSpine'
import { reloadOnceForChunkMismatch } from '@/utils/chunkReloadRecovery'

const AUDIO_PLAY_ABORT_PATTERN =
  /The play\(\) request was interrupted by a call to pause\(\)/

window.addEventListener('vite:preloadError', (event) => {
  reloadOnceForChunkMismatch(event)
})

window.addEventListener('error', (event) => {
  reloadOnceForChunkMismatch(event?.error || event)
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason || event
  const message = reason?.message || String(reason || '')

  if (AUDIO_PLAY_ABORT_PATTERN.test(message)) {
    event.preventDefault()
    return
  }

  reloadOnceForChunkMismatch(reason)
})

initAudioCacheServiceWorker()

async function init() {
  redirectFirebaseHostToCustomDomain()
  const redirected = await redirectByGeoIfNeeded()
  if (redirected) return
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

init()
